export const NODE_ENV = process.env.NODE_ENV;
export const ASSERT_MANAGEMENT_API_ENDPOINT =
  process.env.ASSERT_MANAGEMENT_API_ENDPOINT;
export const ADD_QUESTIONS_API_ENDPOINT = `${process.env.ASSERT_MANAGEMENT_API_ENDPOINT}/ABC`;
export const REACT_APP_AUTHENTICATE_TOKEN_NAME =
  process.env.REACT_APP_AUTHENTICATE_TOKEN_NAME;
export const REACT_APP_DOMAIN = process.env.REACT_APP_DOMAIN;
export const REACT_APP_TENANT_ID = process.env.REACT_APP_TENANT_ID;
export const CMS_API_ENDPOINT = process.env.CMS_API_ENDPOINT;
export const ASSET_MANAGEMENT_ENDPOINT = process.env.ASSET_MANAGEMENT_ENDPOINT;
export const REACT_APP_LOGIN_GATEWAY_API_ENDPOINT =
  process.env.REACT_APP_LOGIN_GATEWAY_API_ENDPOINT;
export const REACT_APP_MDS_URL = process.env.REACT_APP_MDS_URL?.trim() ?? "";
export const REACT_APP_TENANT_MANAGEMENT_URL =
  process.env.REACT_APP_TENANT_MANAGEMENT_URL?.trim() ?? "";
export const UAM_API_ENDPOINT = process.env.UAM_API_ENDPOINT;
export const SIDEBAR_DRAWER_WIDTH = 300;

export const TENANT_ID = "1";

export const PRODUCT_ID = "300";

export const CREATE_PACKAGE_SCRIPT_ID = 5;

export const CREATE_PRODUCT_OFFERINGS_SCRIPT_ID = 8;

export const UPLOAD_FEATURE_OFFERINGS_TO_PACKAGES_SCRIPT_ID = 6;

export const CURRENCY_ID = 1;

export const ADMIN_SUPPORT_MODULE_ID = 3;

export const REACT_APP_OMS_URL = process.env.REACT_APP_OMS_URL?.trim() ?? "";

export const OMS_TENANT = process.env.REACT_APP_OMS_TENANT || "infinitylearn";

export const UPLOAD_PACKAGE_SCHEDULE_SCRIPT_ID = 9;

export const UPDATE_PACKAGE_SCHEDULE_SCRIPT_ID = 11;

export const UPDATE_OR_UPLOAD_PACKAGE_PAYMENT_HEAD_SCRIPT_ID = 12;

export const BULK_CREATE_SCRIPT_ID = 21;

export const BULK_EDIT_SCRIPT_ID = 22;

export const BULK_UPSERT_SUBSCRIPTION_PRICE_SCRIPT_ID = 25;

export const BULK_UPSERT_BOOKS_PRICE_SCRIPT_ID = 26;

export const FILE_UPLOAD_STATUS = {
  CREATED: 1,
  UPLOADED: 2,
  PROCESSED: 3,
};

export const FILTER_ALL_VALUE = "all";

export const DEFAULT_PAGE_NUMBER = 1;

export const DEFAULT_PAGE_SIZE = 10;

export const PAGE_SIZE_OPTIONS = [10, 25, 50];

export const DEFAULT_UPLOAD_DATE_RANGE_ID = "30";

export const PACKAGE_SELECTOR_PAGE_SIZE = 6;

export const DATE_RANGE_OPTIONS = [
  { id: "7", label: "Last 7 Days", days: 7 },
  { id: "30", label: "Last 30 Days", days: 30 },
  { id: "90", label: "Last 90 Days", days: 90 },
  { id: "all", label: "All Time", days: null },
];

export const UPLOAD_STATUS_FILTER_OPTIONS = [
  { id: "all", label: "All Status" },
  { id: "processed", label: "Processed" },
  { id: "uploaded", label: "Uploaded" },
  { id: "failed", label: "Failed" },
];

export const MAX_UPLOAD_FILE_SIZE_MB = 5;
export const MAX_UPLOAD_FILE_SIZE_BYTES = MAX_UPLOAD_FILE_SIZE_MB * 1024 * 1024;
export const MAX_UPLOAD_FILE_ROWS = 500;

export const UPLOAD_ACTION_OPTIONS = [
  {
    id: 1,
    label: "Create Packages",
    scriptId: CREATE_PACKAGE_SCRIPT_ID,
    uploadLabel: "Upload Packages",
    infoText: "Upload CSV file to create new packages in the system.",
  },
  {
    id: 2,
    label: "Create Product Offerings",
    scriptId: CREATE_PRODUCT_OFFERINGS_SCRIPT_ID,
    uploadLabel: "Upload Product Offerings",
    infoText: "Upload CSV file to create product offerings.",
  },
  {
    id: 3,
    label: "Upload Feature Offerings to Packages",
    scriptId: UPLOAD_FEATURE_OFFERINGS_TO_PACKAGES_SCRIPT_ID,
    uploadLabel: "Upload Feature Offerings",
    infoText: "Upload CSV file to map feature offerings to packages.",
  },
  {
    id: 4,
    label: "Upload Package Schedule",
    scriptId: UPLOAD_PACKAGE_SCHEDULE_SCRIPT_ID,
    uploadLabel: "Upload Package Schedule",
    infoText: "Upload CSV file to add package schedules.",
  },
  {
    id: 5,
    label: "Update Package Schedule",
    scriptId: UPDATE_PACKAGE_SCHEDULE_SCRIPT_ID,
    uploadLabel: "Update Package Schedule",
    infoText: "Upload CSV file to update existing package schedules.",
  },
  {
    id: 6,
    label: "Upload/Update Package Payment Head",
    scriptId: UPDATE_OR_UPLOAD_PACKAGE_PAYMENT_HEAD_SCRIPT_ID,
    uploadLabel: "Upload/Update Package Payment Head",
    infoText: "Upload CSV file to create or update package payment heads.",
  },
  {
    id: 7,
    label: "Bulk Create Coupons",
    scriptId: BULK_CREATE_SCRIPT_ID,
    uploadLabel: "Bulk Create Coupons",
    infoText: "Upload CSV file to bulk create coupons.",
  },
  {
    id: 8,
    label: "Bulk Edit Coupons",
    scriptId: BULK_EDIT_SCRIPT_ID,
    uploadLabel: "Bulk Edit Coupons",
    infoText: "Upload CSV file to bulk edit coupons.",
  },
  {
    id: 9,
    label: "Upload Subscription Price",
    scriptId: BULK_UPSERT_SUBSCRIPTION_PRICE_SCRIPT_ID,
    uploadLabel: "Upload Subscription Price",
    infoText: "Upload CSV file to bulk upsert subscription tenant prices.",
  },
  {
    id: 10,
    label: "Upload Books Price",
    scriptId: BULK_UPSERT_BOOKS_PRICE_SCRIPT_ID,
    uploadLabel: "Upload Books Price",
    infoText: "Upload CSV file to bulk upsert books prices.",
  },
];
